module.exports = __webpack_public_path__ + "img/1557614077794131969.2bc62e5c.png";